module.exports = __webpack_public_path__ + "img/max.7f0ff664.png";